module.exports = __webpack_public_path__ + "static/img/z_btn_ask.bc7302d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengwu/z_btn_ask.png
// module id = PCxS
// module chunks = 1